import React, { Component } from "react";
import getObj from "lodash/get";
import { connect } from "react-redux";
import { Form, Input, Card, Button, Row, Col, message, Radio, Descriptions, Select} from "antd";
import axios from "services/axios";
import { getValue } from "../utils";

const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const Option = Select.Option;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
};

const kelengkapanFormLayout = {
  labelCol: {
    xs: { span: 6 },
    sm: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 18 },
    sm: { span: 14 },
  },
};

const kelengkapan = [
  {
    label: "Kunci Cadangan",
    fieldName: "kunciCadangan",
  },
  {
    label: "Ban Cadangan",
    fieldName: "banCadangan",
  },
  {
    label: "BPKB",
    fieldName: "BPKB",
  },
  {
    label: "Faktur",
    fieldName: "faktur",
  },
  {
    label: "NIK/VIN",
    fieldName: "NIK/VIN",
  },
  {
    label: "Buku Servis",
    fieldName: "bukuServis",
  },
  {
    label: "Form A",
    fieldName: "formA",
  },
  {
    label: "Kwitansi Blanko",
    fieldName: "kwitansiBlanko",
  },
  {
    label: "STNK (PT)",
    fieldName: "STNK",
  },
  {
    label: "SPH (PT)",
    fieldName: "SPH",
  },
  {
    label: "NPWP (PT)",
    fieldName: "NPWP",
  },
  {
    label: "SIUP (PT)",
    fieldName: "SIUP",
  },
  {
    label: "Surat Kuasa Perpanjangan (PT)",
    fieldName: "SKPerpanjangan",
  },
  {
    label: "TDP (PT)",
    fieldName: "TDP",
  },
  {
    label: "Domisili (PT)",
    fieldName: "domisili",
  },
];

const options = [
  { label: "Available", value: "yes" },
  { label: "Not Available", value: "no" },
];

class DocumentApproval extends Component {
  state = {
    bookingId: "",
    grade: "",
    licensePlate: "",
    price: "",
    notes: "",
    couriers:[]
  };

  componentDidMount = async () => {
    try {
      console.log(this.props.Auth)
      let { id } = this.props.match.params;
      let req = await axios.get(`/handover/${id}`);
      let {data: {couriers}} = await axios.get(`/misc/couriers`)
      console.log(req)
      this.setState({
        ...req.data.handover,
        appraisal: req.data.appraisal,
        inquiry: req.data.inquiry,
        couriers
      });
    } catch (err) {
      console.error(err);
      message.error("Error, Can't fetch inquiry detail");
    }
  };

  onClickApproval(approved) {
    const {inquiry} = this.state;
    this.props.form.validateFieldsAndScroll((err, values) => {
        inquiry.misc.BPKB = values.BPKB
        let handoverPayload = {
          documentApproval: approved,
          FinanceAdminNotes: values.financeAdminNotes,
          documentSubmitted: approved,
          courier: values.courier,
          inquiryMisc: inquiry.misc,
        }
      axios.put(`/handover/${this.state.id}/document-approval`, handoverPayload)
      .then ( res => {
        message.success("You have been updated this document");
        this.props.history.push("/home/internal-bidding/finance");
      })
      .catch ( err => {
        message.error("You failed to approve this handover");
      })
    })
  }

  kelengkapanValue (value) {
    if (value !== "Available") {
      value !== "yes" ? value = "no" : value
    } else {
      value= "yes"
    }
    return value
  }

  selectChange = value => {
    this.setState({
      courier: value,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { appraisal, Booking, inquiry, couriers } = this.state;

    return this.state.id ? (
      <Form layout="vertical" style={{ marginTop: "30px" }}>
        <Card>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Descriptions size="small" title="Car Information" column={1} bordered={true}>
                {[
                  "carDetail[7]",
                  "carDetail[5]",
                  "carDetail[10]",
                  "carDetail[11]",
                  "carDetail[6]", 
                  "carDetail[12]", 
                  "carDetail[13]"
                ].map((field, index) => {
                  return getObj(appraisal, field).fieldName === "Warna Eksterior" 
                  ? (
                    <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                      {getValue(appraisal.carSummary, "Kategori Warna") !== "" 
                      ? getValue(appraisal.carSummary, "Kategori Warna")
                      : getObj(appraisal, field).value}
                    </Descriptions.Item>
                  )
                  : (
                    <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                      {getObj(appraisal, field).value}
                    </Descriptions.Item>
                  )
                }
                )}
              </Descriptions>
            </Col>
            <Col xs={24} md={12}>
              <Descriptions size="small" title="Sales Informartion" column={1} bordered={true}>
                <Descriptions.Item label="Nama Sales">  {getObj(Booking, "SalesProfile.name")} </Descriptions.Item>
                <Descriptions.Item label="Nama Cabang"> {getObj(Booking, "SalesProfile.branch")} </Descriptions.Item>
                <Descriptions.Item label="No. Hp"> {getObj(Booking, "SalesProfile.phone")} </Descriptions.Item>
                <Descriptions.Item label="Nama SS"> {getObj(Booking, "")} </Descriptions.Item>
              </Descriptions>

              <Descriptions size="small" title="Customer Information" column={1} bordered={true} style={{marginTop: 10}}>
                {["carDetail[0]", "carDetail[2]", "carDetail[1]"].map((field, index) => (
                  <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                    {getObj(appraisal, field).value}
                  </Descriptions.Item>
                ))}
              </Descriptions>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Card title="Kelengkapan" style={{marginTop: 30}}>
                {kelengkapan.map((item, index) => (
                  <FormItem label={item.label} {...kelengkapanFormLayout} key={index}>
                    {getFieldDecorator(item.fieldName, {
                      rules: [{ require: true, message: "Kelengkapan Wajib Diisi" }],
                      initialValue: inquiry.misc ? this.kelengkapanValue(inquiry.misc[item.fieldName]) : "yes",
                    })(<RadioGroup options={options} disabled={item.label !== "BPKB"}/>)}
                  </FormItem>
                ))}
              </Card>
            </Col>

            <Col xs={24} md={12}>
              <Card title="Dokumen Handover" style={{marginTop: 30}}>
                {this.state.misc.map((item, index) => (
                  <FormItem label={item.fieldname} {...kelengkapanFormLayout} key={index}>
                    {getFieldDecorator(item.fieldname, {
                      rules: [{ require: true, message: "Kelengkapan Dokumen Handover Wajib Diisi" }],
                      initialValue: item.value,
                    })(<RadioGroup options={options} disabled/>)}
                  </FormItem>
                ))}
              </Card>
            </Col>
          </Row>

          <Row gutter={16}>
            <Card title="Finance Form" style={{ marginTop: "30px" }}>
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <FormItem label="Lokasi Handover" {...formItemLayout}>
                    {getFieldDecorator("location", {
                      initialValue: this.state.location,
                    })(
                      <Input disabled/>,
                    )}
                  </FormItem>

                  <FormItem label="Lokasi Penyimpanan Mobil" {...formItemLayout}>
                    {getFieldDecorator("branchOffice", {
                      initialValue: this.state.inquiry.branchOffice || "",
                    })(<Input disabled />)}
                  </FormItem>

                  <FormItem label="Catatan Supervisor" {...formItemLayout}>
                    {getFieldDecorator("acquistorNotes", {
                      initialValue: this.state.acquisitorNotes
                    })(
                      <Input.TextArea disabled/>,
                    )}
                  </FormItem>

                  <FormItem label="Catatan Driver" {...formItemLayout}>
                    {getFieldDecorator("driverNotes", {
                      initialValue: this.state.driverNotes
                    })(<Input.TextArea disabled />)}
                  </FormItem>

                  <FormItem label="Catatan dari Document Admin" {...formItemLayout}>
                    {getFieldDecorator("documentAdminNotes", {
                      initialValue: this.state.DocumentAdminNotes
                    })(<Input.TextArea disabled/>)}
                  </FormItem>
                </Col>

                <Col xs={24} md={12}>
                  <FormItem label="Nomor Mesin" {...formItemLayout}>
                    {getFieldDecorator("nomorMesin", {
                      initialValue: appraisal.carDetail[8].value
                    })(<Input disabled />)}
                  </FormItem>

                  <FormItem label="Nomor Rangka" {...formItemLayout}>
                    {getFieldDecorator("nomorRangka", {
                      initialValue: appraisal.carDetail[9].value
                    })(<Input disabled />)}
                  </FormItem>

                  <FormItem label="Pilih Kurir" {...formItemLayout}>
                    {getFieldDecorator("courier", {
                      initialValue: this.state.courier || "",
                    })(
                    <Select
                      showSearch
                      placeholder="Select a person"
                      optionFilterProp="children"
                      onChange={this.selectChange}
                      style={{ width: "100%" }}
                      filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                      {couriers.map((courier, index) => {
                        return (
                          <Option key={courier.id} value={courier.name}>
                            {courier.name}
                          </Option>
                        );
                      })}
                    </Select>
                    )}
                    </FormItem>

                  <FormItem label="Catatan" {...formItemLayout}>
                    {getFieldDecorator("financeAdminNotes", {
                      initialValue: this.state.FinanceAdminNotes
                    })(<Input.TextArea />)}
                  </FormItem>
                </Col>
              </Row>

              <Row style={{ float: "right" }}>
                <Col span={24}>
                <Button type="primary" onClick={() => this.onClickApproval(true)} style={{marginLeft: 10}} htmlType="button">
                  Approve Document
                </Button>

                <Button type="danger" onClick={() => this.onClickApproval(false)} style={{marginLeft: 10}} htmlType="button">
                  Reject Document
                </Button>
                </Col>
              </Row>
            </Card>
          </Row>
        </Card>
      </Form>
    ) : null;
  }
}

const FormDocumentApproval = Form.create()(DocumentApproval);
const mapStateToProps = ({ Auth }) => ({ Auth });

export default connect(mapStateToProps)(FormDocumentApproval);


// WEBPACK FOOTER //
// src/components/Dashboard/InternalBidding/Finance/FinanceUpdate.js